import { createTipsStore } from '@edwin/stores'
import { edwinCloudApiClient } from '@services/EdwinCloudApiClient'

export const useTipsStore = createTipsStore({
  sessionStorage: window.localStorage,
  apiClient: edwinCloudApiClient,
})

export default useTipsStore
